export { closest, FOCUSABLE, matches, moveFocusToNext } from './dom';